export enum QuoteMediaConnectionStatus {
  NotConnected,
  Connecting,
  Connected
}